import React from "react";

const Work = () => {
  return <div>work</div>;
};

export default Work;
